import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import EmailIcon from 'mdi-react/EmailIcon';
import PhoneIcon from 'mdi-react/PhoneIcon';
import './stylevn.css';

function FooterVn() {

    return (
        <div id="footer">
            <div class="footer-top">
                <div class="fit-block footer-body container">
                    <div class="row">
                        <div class="logo-footer">
                            <div class="MuiBox-root css-0">
                                <div class="logo-footer-detail MuiBox-root css-0"><img class="logo-footer-img"
                                    src="https://hanbiro.com/cloud/library/cloudconsult/logo-footer.svg"
                                    alt="imagecloud" />
                                    <p class="typography-message">· Trụ sở : Tầng 4 và 5, số 9
                                        Nambusunhwan-ro 333-gil, Seocho-gu, Seoul (Seocho-dong, Tòa nhà Hyochon) |
                                        Tầng 4 và 5, Tòa nhà Hyochon, 1425-10, Seocho 1-dong, Seocho-gu, Seoul<br />
                                        · Mỹ: 711 S. VERMONT AVE.STE 209 LOS ANGELES, CA 90005<br />
                                        · Trung Quốc : Phòng 1108G, Tầng 11, Tòa nhà A, Tianli Central Business Plaza, Đường
                                        Houhai Avenue East, Quận Nanshan, Thâm Quyến<br />
                                        · Việt Nam : Lô A4a, Đường 19C, Khu CNC E-Office, Phường Tân Thuận Đông, Quận 7,
                                        TPHCM, Việt Nam<br />
                                        · Phòng điều hành máy chủ : Tầng 2, Trung tâm KIDC Seocho 1, 1423-1 Seocho-dong,
                                        Seocho-gu, Seoul<br />
                                        <EmailIcon className="icon-text" />
                                        <a href="mailto:hanbiro@hanbiro.com"
                                            class="text-color text-pur-color">hanbiro@hanbiro.com</a>
                                        &nbsp;&nbsp;&nbsp;
                                        <PhoneIcon className="icon-text" />
                                        Số điện thoại: <a href="tel:1800 6346" class="text-color text-pur-color">1800
                                            6346</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div>
                <div class="footer-bottom">
                    <div class="fit-block">
                        <p>All Right Reserved © Hanbiro, Inc.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FooterVn;
